import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import UserActions from '../../actions/UserActionCreator';
import UserSkillStore from '../../stores/UserSkillStore';
import UserSkillSegment from './UserSkillSegment';


class UserSkillContainer extends Component {

    componentDidMount() {
        UserActions.getSkillsByUser(this.props.userId);
    }

    render() {

        return (
            <UserSkillSegment skills={this.state.skills} {...this.props} />
        );
    }
}

UserSkillContainer.getStores = () => ([UserSkillStore]);
UserSkillContainer.calculateState = (prevState, {userId}) => ({
    skills: UserSkillStore.getCurrent(userId) || [],
});

UserSkillContainer.propTypes = {
    userId: PropTypes.number.isRequired,
    menuItems: PropTypes.array
};


export default Container.create(UserSkillContainer, {withProps: true});
